<template>
  <div v-if="show" class="d-flex flex-row align-items-center justify-content-end gap-2 fw-semibold">
    <b-tooltip v-if="letterCount > 0" :title="letterTooltip" placement="top">
      <div class="position-relative">
        <i class="bi bi-envelope"/>
        <span v-if="hasPendingLetters" class="position-absolute top-0 start-100 p-1 bg-primary rounded-circle"/>
      </div>
    </b-tooltip>
    <b-tooltip v-if="property.isWhitelisted" :title="deferralTooltip" placement="top">
      <i class="bi bi-clock"/>
    </b-tooltip>
    <b-tooltip v-else-if="property.hasEndedDeferral" :title="endedDeferralTooltip" placement="top">
      <i class="bi bi-clock-history text-muted"/>
    </b-tooltip>
    <status-badge v-if="!property.isViolationSeen" variant="primary">
      New
    </status-badge>
  </div>
</template>

<script>
import {Property} from "@/models/Property";
import StatusBadge from "@/components/common/StatusBadge.vue";

export default {
  components: {StatusBadge},
  props: {
    property: Property
  },
  computed: {
    letterTooltip() {
      const parts = [`${this.letterCount} total`];
      if (this.pendingLetterCount > 0) {
        parts.push(`${this.pendingLetterCount} pending`);
      }
      return `Letters: ${parts.join(' · ')}`;
    },
    letterCount() {
      if (this.property.data.letterCounts) return this.property.data.letterCounts.total;
      return this.property.correspondences.filter(letter => !letter.isCancelled).length;
    },
    pendingLetterCount() {
      if (this.property.data.letterCounts) return this.property.data.letterCounts.printed || 0;
      return this.property.correspondences.filter(letter => letter.isPrinted).length;
    },
    hasPendingLetters() {
      return this.pendingLetterCount > 0;
    },
    deferralTooltip() {
      const exp = this.property.whitelistExpiration;
      return exp ? `Deferred until ${exp.format('MMM D, YYYY')}` : 'Deferred indefinitely';
    },
    endedDeferralTooltip() {
      const end = this.property.deferralEndDate;
      return end ? `Deferral ended ${end.format('MMM D, YYYY')}` : 'Previously deferred';
    },
    show() {
      return this.letterCount > 0 || this.property.isWhitelisted || this.property.hasEndedDeferral || !this.property.isViolationSeen;
    }
  }
}
</script>
